import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const MASupportDueDiligence = () => {
  const serviceData = {
    title: "Mergers & Acquisitions (M&A) Support",
    heading: "Mergers & Acquisitions (M&A) Support",
    image: subTopicImages["M&A Support & Due Diligence"],
    intro:
      "Strategic and regulatory advisory across the full M&A lifecycle — from evaluation to implementation",
    description: [
      "Mergers & Acquisitions are among the most strategic capital decisions an organisation undertakes. Whether the objective is expansion, consolidation, restructuring, succession planning or investor realignment, a transaction must be evaluated and executed with financial discipline, legal compliance and governance oversight.",
      "At V DOOGAR AND ASSOCIATES, we provide end-to-end M&A advisory support — helping promoters, Boards, multinational groups and investors navigate transactions confidently and efficiently. Our team supports clients across both strategic evaluation and regulatory implementation, ensuring that the deal is not only commercially viable but also fully compliant.",
    ],
    services: [
      {
        title: "Our M&A Services Cover",
        list: [
          "Strategic & Commercial Evaluation — We assess the business rationale, value drivers, synergy opportunities and financial impact of a proposed transaction — helping management take informed decisions.",
          "Financial Assessment & Pricing Inputs — We support value analysis, valuation coordination and pricing considerations — ensuring negotiations are grounded in financial reality.",
          "Deal Structuring & Term Design — We advise on investment structures, shareholding arrangements, consideration mechanisms and regulatory pathways, aligned with Indian law and tax frameworks.",
          "Support During Negotiations & Documentation — We work closely with legal counsel, merchant bankers and advisors to ensure commercial intent is accurately reflected in transaction documents.",
          "Regulatory & Implementation Support — We assist clients in executing the transaction from a regulatory and filing perspective, including Companies Act compliance, FEMA/RBI aspects (where foreign investment exists), tax and reporting considerations, documentation and approvals, coordination with statutory authorities & advisors.",
        ],
        extraInfo:
          "Our approach ensures smooth execution from term sheet to legal closure.",
      },
      {
        title: "Fast Track Mergers — Specialist Support",
        list: [
          "mergers of small companies",
          "mergers of holding & wholly-owned subsidiaries",
          "internal group reorganisations",
        ],
        extraInfo:
          "We support clients through eligibility assessment & structuring, drafting scheme and supporting documentation, Board & shareholder approvals, regulatory submissions & representations, coordination with professionals & authorities, accounting and tax structuring inputs, post-merger implementation support. Our role ensures regulatory accuracy, proper sequencing and end-to-end execution management.",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default MASupportDueDiligence;
